import { useMemo } from 'react';
import { Field, FieldTypes, ProcessingRuleItem } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { REQUIRED_TEXT } from '@/common/constants';
import { ProcessingRuleType } from '@/modules/HealthPlan/HealthPlan.types.ts';
import { useFieldsWithDefaultValues } from '@/utils';

import { MainInfo, PROCESSING_RULE_TYPE_KEY } from '../ProcessingRuleModal.types';

const PROCESSING_RULE_TYPE_OPTIONS = [
  {
    label: 'Aggregate only',
    value: ProcessingRuleType.AGGREGATE_ONLY,
  },
  {
    label: 'Embedded only',
    value: ProcessingRuleType.EMBEDDED_ONLY,
  },
  {
    label: 'Combined',
    value: ProcessingRuleType.COMBINED,
  },
];

export default (
  defaultValues?: Partial<MainInfo>,
  updatedElement?: ProcessingRuleItem,
  errors?: Partial<MainInfo>
) => {
  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'name',
        type: FieldTypes.Text,
        label: 'Processing rule name',
        placeholder: 'Enter name',
        showRequireIcon: true,

        validator: yup
          .string()
          .test({
            test: (val) => val !== errors?.name || !errors?.name,
            message: 'This name is already used by another processing rule',
          })
          .required(REQUIRED_TEXT),
        defaultValue: updatedElement?.name || '',
      },
      {
        name: PROCESSING_RULE_TYPE_KEY,
        type: FieldTypes.Radio,
        label: 'Processing rule type',
        showRequireIcon: true,
        options: PROCESSING_RULE_TYPE_OPTIONS,
        defaultValue: ProcessingRuleType.COMBINED,
        validator: VALIDATORS.REQUIRED_STRING,
      },
    ],
    [errors, updatedElement]
  );

  return useFieldsWithDefaultValues(fields, defaultValues);
};
